<app-header></app-header>
<div class="router-outlet">
    <router-outlet></router-outlet>
</div>

<app-footer></app-footer>
<app-cookie-consent-banner></app-cookie-consent-banner>
<app-toast-host></app-toast-host>
